export function formatAccessTime(startsAt: string, endsAt?: string): string {
  if (!startsAt) return '';
  const dStart = new Date(startsAt);
  const dEnd = endsAt ? new Date(endsAt) : null;

  if (isNaN(dStart.getTime())) return startsAt;

  const dateStr = dStart.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });

  const startTimeStr = dStart.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });

  const endTimeStr = dEnd && !isNaN(dEnd.getTime())
    ? dEnd.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
      })
    : '';

  return endTimeStr ? `${dateStr}, ${startTimeStr} — ${endTimeStr}` : `${dateStr}, ${startTimeStr}`;
}
